/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The lock items query paginated response.
 */
export interface QueryLocksResponse { 
    /**
     * The number of items in this page of query result.
     */
    page_items_count?: number;
    /**
     * The item number (in the total locks) that the page result starts with.
     */
    page_start_item_number?: number;
    /**
     * The total number of items in the query result.
     */
    total_items_count?: number;
    /**
     * The lock items from the query result, each containing containing granular locks.
     */
    lock_item_list: Array<object>;
}

